import { render, staticRenderFns } from "./commissionDetail.vue?vue&type=template&id=a9d7f83c&scoped=true"
import script from "./commissionDetail.vue?vue&type=script&lang=js"
export * from "./commissionDetail.vue?vue&type=script&lang=js"
import style0 from "./commissionDetail.vue?vue&type=style&index=0&id=a9d7f83c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d7f83c",
  null
  
)

export default component.exports